<template>
    <v-col cols="12" sm="6" class="py-10 py-lg-40">
        <div class="w-100 pt-20 pt-md-30 pt-lg-34 border-top">
            <v-img :src="icon" :max-width="iconWidth" class="mb-12 mb-lg-30"></v-img>
            <h5 class="tit--sm font-weight-medium mb-6 mb-lg-14" v-if="tit">
                {{tit}}
            </h5>
            <slot/>
        </div>
    </v-col>
</template>

<script>

export default{
    props : {
        icon : {type :String, default : ""},
        iconWidth : {type :String, default : ""},
        tit : {type :String, default : ""},
    },
    components: {
    },
    data: () => {
        return {
        }
    },
	created() {
	},
	// mounted() {
	// 	this.init();
	// },
	// methods : {
	// 	init : function() {
    //         setTimeout(() => {
    //             AOS.init({
    //                 once: false,
    //                 offset: 240,
    //                 duration: 500,
    //                 throttleDelay : 100,
    //                 easing : 'ease-in-out',
    //                 anchorPlacement : 'top-center',
    //             });
    //         }, 100);
	// 	}
	// },
}
</script>

<style scoped>
</style>